import context from '@truckdown/components-systems';
import { AccountSummaryModel, UpdateAccountSystemInfo, AccountStatus, AccountType, IAccountManager } from "@truckdown/accounts";
import { defineComponent, ref, Ref, computed } from "vue";

type AccountTypeList = Exclude<AccountType, AccountType.None>;
type AccountStatusList = Exclude<AccountStatus, AccountStatus.None>;

interface IData {
    isLoading: Ref<boolean>,
    model: Ref<IFormData>,
    errorMessage: Ref<string>
};

interface IFormData {
    name: string;
    status: AccountStatusList;
    type: AccountTypeList;
}

const getInitialData = function (props: any) {
    let model = {
        name: props.accountSummary.n,
        status: props.accountSummary.status,
        type: props.accountSummary.accountType
    } as IFormData;

    return {
        isLoading: ref<boolean>(false),
        model: ref<IFormData>(model),
        errorMessage: ref<string>('')
    } as IData;
}

const getMethods = function (props: any, data: IData, ctx: any) {
    return {
        editAccountHeaderCancelClick: function (): void {
            ctx.emit(accountCancelEventName);
        },
        editAccountHeaderSaveClick: async function (): Promise<void> {
            await saveUser(data, props, ctx);
        },
        getStatusDisplay: function (status: AccountStatus) {
            return AccountStatus[status];
        },
        getTypeDisplay: function (type: AccountType) {
            return AccountType[type];
        }
    }
}

const getComputed = function () {
    return {
        statusList: computed(() => {
            var res = Object.keys(AccountStatus).filter((key) => key != "0" && !isNaN(Number(key)));

            return res;
        }),
        typeList: computed(() => {
            var res = Object.keys(AccountType).filter((key) => key != "0" && !isNaN(Number(key)));

            return res;
        })
    }
}

const saveUser = async function (data: IData, props: any, ctx: any): Promise<void> {
    if (!data.isLoading.value) {
        data.isLoading.value = true;

        try {
            let accountManager = await context.getService<IAccountManager>('IAccountManager');

            data.errorMessage.value = '';

            var updateAccountSystemInfo = {
                accountId: props.accountSummary.id,
                name: data.model.value.name,
                status: Number(data.model.value.status),
                type: Number(data.model.value.type),
                parentId: props.accountSummary.parentAccount?.id ?? undefined,
                dealerNetwork: props.accountSummary.info.dealerNetwork,
                sites: props.accountSummary.info.sites,
                isPaid: props.accountSummary.isPaid
            } as UpdateAccountSystemInfo;

            var response = await accountManager.updateSystemInfo(updateAccountSystemInfo);

            if (!response || !response.ok) {
                data.errorMessage.value = response.message ?? "";
                console.log("Error updating account information.");
            } else {
                ctx.emit(accountUpdatedEventName, response.data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            data.isLoading.value = false;
        }
    }
}

const accountUpdatedEventName = 'update';
const accountCancelEventName = 'cancel';

export default defineComponent({
    props: {
        accountSummary: {
            type: Object as () => AccountSummaryModel,
            required: true
        }
    },
    components: {
    },
    emits: [accountUpdatedEventName, accountCancelEventName],
    setup: function (props, ctx) {
        let data = getInitialData(props);
        let computed = getComputed();
        let methods = getMethods(props, data, ctx);

        return {
            ...data,
            ...computed,
            ...methods
        };
    }
});